import axiosInstance from 'api/axios';

export enum ImageToolTypeEnum {
  BG_REMOVAL = 'BG_REMOVAL',
  OBJECT_REMOVAL = 'OBJECT_REMOVAL',
  UPSCALE = 'UPSCALE',
  IMAGE_INPAINT = 'IMAGE_INPAINT',
  SEARCH_REPLACE = 'SEARCH_REPLACE',
  SEARCH_RECOLOR = 'SEARCH_RECOLOR',
}

interface APIResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

interface IGenerateImageFromTextRequestPayload {
  input: string;
  prompt_type: string;
  token?: string | undefined;
}

interface IGenerateImageFromTextResponse {
  image_url: string;
}

interface ISaveImageEditorGeneratedImagePayload {
  image_name: string;
  image_url: string;
  tool_type: string;
}

interface ISaveGeneratedImagePayload {
  input: string;
  prompt_type: string;
  img_url: string;
  file_name: string;
}

interface ISaveGeneratedImageResponse {
  data: string;
}

interface IRecentImagesResponse {
  created_at: string;
  id: number;
  img_url: string;
  prompt_input: string;
  prompt_type: string;
}

interface IUserImagesResponse {
  created_at: string;
  id: number;
  img_url: string;
  prompt_input: string;
  prompt_type: string;
}

export interface IUpdateImagePayload {
  input: string;
  prompt_type: string;
  token: string;
}

export const ImageGenService = {
  // Generate image from text
  generateImageFromText: async (
    payload: IGenerateImageFromTextRequestPayload
  ): Promise<APIResponse<IGenerateImageFromTextResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/text-to-image/generate',
      payload
    );
    return response.data;
  },

  // Save generated image
  saveGeneratedImage: async (
    payload: ISaveGeneratedImagePayload
  ): Promise<APIResponse<ISaveGeneratedImageResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/text-to-image/',
      payload
    );
    return response.data;
  },

  saveImageEditorGeneratedImage: async (
    payload: ISaveImageEditorGeneratedImagePayload
  ): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/gen-ai/save-image',
      payload
    );
    return response.data;
  },

  // Get all recent images
  getRecentImage: async (): Promise<APIResponse<IRecentImagesResponse[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/text-to-image/recent'
    );
    return response.data;
  },

  // Get user images
  getUserImages: async (): Promise<APIResponse<IUserImagesResponse[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/text-to-image/user'
    );
    return response.data;
  },

  // Update image
  updateImage: async (
    imageId: number,
    payload: IUpdateImagePayload
  ): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.put(
      `/api/v1/text-to-image/${imageId}`,
      payload
    );
    return response.data;
  },

  // Delete image
  deleteImage: async (imageId: number): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/text-to-image/${imageId}`
    );
    return response.data;
  },

  // Generate image from random prompt
  generateImageFromRandomPrompt: async () => {
    const response = await axiosInstance.public.get(
      '/api/v1/text-to-image/random/prompt'
    );
    return response.data;
  },
};
